// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--28I70","header":"layout-module--header--3n1kX","content":"layout-module--content--dHzMz","footer":"layout-module--footer--1hz3q"};